import { action, observable } from "mobx";
import { createContext } from "react";
import { ListLinkProps } from "../components/SideMenu/ListLink";
import { DialogSpecsProps } from "../components/Dialog/ConfirmationDialog";
import { EventManager } from "../dataAccess/EventManager";

export interface Defaults {
  dateFormat: string;
  emptyString: string;
}

export interface ApiVersion {
  branch: string;
  buildTime: string;
  commitId: string;
  commitIdDescribeShort: string;
  commitTime: string;
  site: string;
}

export interface CommonError extends Error {
  message: string;
  errors?: FieldError[];
}

export interface FieldError {
  fieldName: string;
  message: string;
}

export interface PopupMessage {
  title: string;
  content?: string;
}

export const DRAWER_EXPANDED = "lego-drawer-expanded";
const isOpenStr = localStorage.getItem(DRAWER_EXPANDED);
const isOpen = isOpenStr ? (JSON.parse(isOpenStr) as boolean) : true;
const saveToLocalStore = (newValue: boolean): void => {
  localStorage.setItem(DRAWER_EXPANDED, JSON.stringify(newValue));
};

export class CommonsStore extends EventManager {
  // deprecated
  public sideMenuItems: ListLinkProps[] = [];
  @observable public error?: CommonError;
  @observable public success?: string;
  @observable public sideMenuDrawerExpanded: boolean = isOpen;
  @observable public dataExchange = false;
  @observable public dialogOpen = false;
  @observable public dialogProps: DialogSpecsProps = {
    title: "",
    content: "",
    onConfirm: () => {},
    onCancel: () => {}
  };

  @observable public apiVersion?: ApiVersion;
  @observable public guiVersion?: string;

  @observable public defaults!: Defaults;

  public constructor() {
    super();
    this.setApiVersion();
    this.setGuiVersion();
    this.resetDefaults();
  }

  @action
  public toggleSideMenuDrawerExpanded() {
    this.sideMenuDrawerExpanded = !this.sideMenuDrawerExpanded;
    saveToLocalStore(this.sideMenuDrawerExpanded);
  }

  @action
  public showDialog(
    content: PopupMessage,
    onConfirmDialog: () => void,
    onCancelDialog?: () => void
  ) {
    this.dialogProps.title = content.title;
    this.dialogProps.content = content.content;
    this.dialogProps.onConfirm = onConfirmDialog;
    this.dialogProps.onCancel = onCancelDialog
      ? onCancelDialog
      : this.closeDialog;
    this.dialogOpen = true;
  }

  @action
  public closeDialog = () => {
    this.dialogOpen = false;
  };

  @action
  public newError(error: CommonError) {
    this.closeSnacks();
    this.error = error;
  }

  @action
  public newSuccess(success: string) {
    this.closeSnacks();
    this.success = success;
  }

  @action
  public setDataExchange() {
    this.dataExchange = true;
  }

  @action
  public resetDataExchange() {
    this.dataExchange = false;
  }

  @action
  public setGuiVersion(guiVersion?: string) {
    this.guiVersion = guiVersion ? guiVersion : "";
  }

  @action
  public setApiVersion(apiVersion?: ApiVersion) {
    this.apiVersion = apiVersion
      ? apiVersion
      : {
          branch: "",
          buildTime: "",
          commitId: "",
          commitIdDescribeShort: "",
          commitTime: "",
          site: ""
        };
  }

  @action
  public closeSnacks() {
    if (this.success !== undefined) {
      this.success = undefined;
    }
    if (this.error !== undefined) {
      this.error = undefined;
    }
  }

  @action
  private resetDefaults() {
    this.defaults = {
      dateFormat: "YYYY/MM/DD HH:mm",
      emptyString: "-"
    };
  }
}

export const commonsStore = new CommonsStore();
export const commonsStoreContext = createContext(commonsStore);
